<template>
  <div>
    <mds-combo-box
      v-model="selectedRecurrence"
      :label="translate('frequency.modal.recurrence.label')"
      :data-set="options"
      :selected-items="[selectedRecurrence]"
      @input="$emit('input', { repeatType: $event[0] })"
    />
    <component
      class="frequency-modal__frequencies"
      :is="recurrenceChildComponent"
      v-bind="recurrenceProps[true]"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import DailyFrequency from '@/components/frequencyModal/frequencies/DailyFrequency.vue'
import WeeklyFrequency from '@/components/frequencyModal/frequencies/WeeklyFrequency.vue'
import MonthlyFrequency from '@/components/frequencyModal/frequencies/MonthlyFrequency.vue'
import defaultConfig from '@/components/frequencyModal/config/i18n'
import {
  COMPONENT_FREQUENCIES,
  RECURRENCE_TIME_VALIDATION,
} from '@/components/frequencyModal/config/constants'

export default {
  name: 'FrequencyRecurrence',
  components: {
    MdsComboBox,
    DailyFrequency,
    WeeklyFrequency,
    MonthlyFrequency,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      selectedRecurrence: [],
      recurrenceOptions: Object.keys(COMPONENT_FREQUENCIES),
    }
  },
  watch: {
    editedSchedule: {
      immediate: true,
      deep: true,
      handler(schedule) {
        if (!isEmpty(schedule)) {
          const recurrence = this.editedSchedule?.frequency?.repeatType

          this.selectedRecurrence =
            this.editedSchedule && recurrence
              ? [this.editedSchedule?.frequency?.repeatType]
              : [Object.keys(COMPONENT_FREQUENCIES)[0]]
        } else {
          this.selectedRecurrence = [Object.keys(COMPONENT_FREQUENCIES)[0]]
        }
        this.$emit('input', { repeatType: this.selectedRecurrence[0] })
      },
    },
  },
  computed: {
    ...mapState({
      editedSchedule: (state) => state.cache.cache.editedSchedule,
    }),
    options() {
      return this.recurrenceOptions.map((rec) => ({
        value: rec,
        text: this.translate(`frequency.modal.recurrenceoption.${rec}`),
      }))
    },
    recurrenceChildComponent() {
      const [recurrence] = this.selectedRecurrence
      const [onlyOnce] = RECURRENCE_TIME_VALIDATION

      // 'Only Once' recurrence does not need to show a child component
      if (recurrence === onlyOnce) {
        return undefined
      }

      return (
        COMPONENT_FREQUENCIES[recurrence] ||
        Object.values(COMPONENT_FREQUENCIES)[1]
      )
    },
    recurrenceProps() {
      return {
        [this.recurrenceChildComponent === COMPONENT_FREQUENCIES.Daily]: {
          dateType: this.editedSchedule?.frequency?.dateType,
        },
        [this.recurrenceChildComponent === COMPONENT_FREQUENCIES.Weekly]: {
          fixedDay: this.editedSchedule?.frequency?.fixedDay,
        },
        [this.recurrenceChildComponent === COMPONENT_FREQUENCIES.Monthly]: {
          dateType: this.editedSchedule?.frequency?.dateType,
          fixedDay: this.editedSchedule?.frequency?.fixedDay,
          ordinal: this.editedSchedule?.frequency?.ordinal,
          weekday: this.editedSchedule?.frequency?.weekday,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.frequency-modal {
  &__frequencies {
    margin-top: $mds-space-1-and-a-half-x;
  }
}
</style>
